import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import { Bookmark, BookmarkType } from "marketplace/bookmarks/bookmark";
import BookmarkedTeamSchema, { BookmarkedTeamJSON, BookmarkedTeamParams } from "marketplace/bookmarks/team-bookmarks/_schema/bookmarked-team-schema";
import Entity from '_framework/entities/entity';

export default class BookmarkedTeam extends Entity<BookmarkedTeam, BookmarkedTeamJSON, BookmarkedTeamParams> implements Bookmark {
  public static get EXAMPLE(): BookmarkedTeam {
    return new BookmarkedTeam({
      id: Guid.generate(),
      createdDate: AHDate.TODAY,
      teamId: Guid.generate()
    });
  }

  public static create(values: BookmarkedTeamParams): BookmarkedTeam {
    const parsed = BookmarkedTeamSchema.validate(values);
    return new BookmarkedTeam(parsed);
  }

  public static fromJSON(json: BookmarkedTeamJSON): BookmarkedTeam {
    const parsed = BookmarkedTeamSchema.deserialize(json);
    return new BookmarkedTeam(parsed);
  }

  public static fromJSONArray(jsonArray: BookmarkedTeamJSON[]): BookmarkedTeam[] {
    return jsonArray.map((json) => BookmarkedTeam.fromJSON(json));
  }


  public readonly id: Guid;
  public readonly createdDate: AHDate;
  public readonly teamId: Guid;

  public get type(): BookmarkType {
    return BookmarkType.Team;
  }

  public constructor(params: BookmarkedTeamParams) {
    super(params);
    this.id = params.id;
    this.createdDate = params.createdDate;
    this.teamId = params.teamId;
  }


  public toJSON(): BookmarkedTeamJSON {
    return BookmarkedTeamSchema.serialize(this);
  }

  public valueOf(): BookmarkedTeamJSON {
    return this.toJSON();
  }

  public toString(): string {
    return `Bookmarked Individual: 
        Id: ${this.id.toString()}
        CreatedDate: ${this.createdDate.toString()}
        TeamId: ${this.teamId.toString()}
      )`;
  }

  public isEqualTo(other: BookmarkedTeam | null | undefined): boolean {
    return Boolean(other
      && this.id.isEqualTo(other.id)
      && this.createdDate.isEqualTo(other.createdDate)
      && this.teamId.isEqualTo(other.teamId)
    );
  }
}
